import "../scss/custom.scss"
import 'bootstrap-vue/dist/bootstrap-vue.css'
import Vue from 'vue';
import VueRouter from 'vue-router'
// import Vuetify from 'vuetify'
import BootstrapVue from 'bootstrap-vue';
import "@fortawesome/fontawesome-free/css/all.css"
import App from './App.vue';
require("./filters.js");
const _ = require('lodash');

Vue.config.productionTip = false

Vue.use(VueRouter);
Vue.use(BootstrapVue);
// Vue.use(Vuetify);

const routes = [
  { path: '/', redirect: '/users' },
  { path: '/users/:id', component: App },
]

const router = new VueRouter({ routes })

new Vue({
  router,
  render: function (h) { return h(App) }
}).$mount('#app')
